
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-approvals",
})
export default class IconApprovals extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;
}
